export function getQueryStringFromObject(params) {
  let qs = '';
  Object.keys(params).forEach((key, index) => {
    if (index !== 0) {
      qs += '&';
    }
    qs += key + '=' + params[key];
  });
  return encodeURI(qs);
}
